import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useI18n } from '../context/I18nContext';
import { SUPPORTED_LANGS } from '../context/I18nContext';

const BASE_URL = 'https://hexo-works.com';

export function HreflangTags() {
  const location = useLocation();
  const { lang } = useI18n();

  useEffect(() => {
    // Remove old hreflang/canonical tags
    document.querySelectorAll('link[data-hreflang]').forEach(el => el.remove());

    const path = location.pathname;

    // Canonical (current lang)
    const canonical = document.createElement('link');
    canonical.rel = 'canonical';
    canonical.href = `${BASE_URL}${path}?lang=${lang}`;
    canonical.setAttribute('data-hreflang', 'canonical');
    document.head.appendChild(canonical);

    // Hreflang alternates for each language
    SUPPORTED_LANGS.forEach(l => {
      const link = document.createElement('link');
      link.rel = 'alternate';
      link.hreflang = l;
      link.href = `${BASE_URL}${path}?lang=${l}`;
      link.setAttribute('data-hreflang', l);
      document.head.appendChild(link);
    });

    // x-default (English)
    const xDefault = document.createElement('link');
    xDefault.rel = 'alternate';
    xDefault.hreflang = 'x-default';
    xDefault.href = `${BASE_URL}${path}?lang=en`;
    xDefault.setAttribute('data-hreflang', 'x-default');
    document.head.appendChild(xDefault);

    // Update html lang attribute
    document.documentElement.lang = lang;
    document.documentElement.dir = lang === 'ar' ? 'rtl' : 'ltr';

    return () => {
      document.querySelectorAll('link[data-hreflang]').forEach(el => el.remove());
    };
  }, [location.pathname, lang]);

  return null;
}
